import React from 'react';
import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import Form from '../../../containers/Form/Form'
import Select from "../../../containers/Form/Select";

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_status_dashboard } from "../../../app/apiEndpoints" //tool_lp_dashboard_boost
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'

import CascadeToolToggle from '../../../containers/CascadeToolToggle';


const CascadeStatusDashboard = (props) => {
    const toolID = 16
    const [tool, setTool] = useState({})

    const [cascadeType, setCascadeType] = useState(0)

    //const [hasErrors, setHasErrors] = useState(false)
    //const [status, setStatus] = useState(0)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [dailyStats, setDailyStats] = useState([])
    const [hourlyStats, setHourlyStats] = useState([])
    const [subpidStats, setSubpidStats] = useState([])
    const [pathLeadStats, setPathLeadStats] = useState([])
    const [pathRevStats, setPathRevStats] = useState([])
    const [pathSuccessStats, setPathSuccessStats] = useState([])
    //const [flows, setFlows] = useState([])
    //const [mobileFlows, setMobileFlows] = useState([])
    //const [lpStats, setLpStats] = useState([])
    const [pids, setPids] = useState([])
    const [geos, setGeos] = useState([])
    //const [paths, setPaths] = useState([])

    //filters
    const [curPid, setCurPid] = useState('')
    const [curGeo, setCurGeo] = useState('')
    //const [curBoosts, setCurBoosts] = useState([])
    //const [curPath, setCurPath] = useState(0)
    //const [boostHours, setBoostHours] = useState(2)
    //const [boostPid, setBoostPid] = useState('')
    //const [formMessage, setFormMessage] = useState('')

    const dayFields = ["Day","Revenue","7-Day Avg","% Delta","Status"];
    const hourFields = ["Hour","Revenue","7-Day Avg","% Delta","Status"];
    const subpidFields = ["Subpid","Leads 0-24h", "24-48h","7-Day Avg","% Delta","Status"];
    const pathFields = ["Path","0-24h","24-48h","48-72h","% Delta","Status"];


    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getStats = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_status_dashboard, { 'requester': userID, 'company': companyID, 'subpid': curPid, 'geo': curGeo, 'cascadeType': cascadeType })
                setDailyStats(data.dailyStats)
                setHourlyStats(data.hourlyStats)
                setSubpidStats(data.subpidStats)
                setPathLeadStats(data.pathLeadStats)
                setPathRevStats(data.pathRevStats)
                setPathSuccessStats(data.pathSuccessStats)

                if(data.pids) setPids(data.pids)
                if(data.geos) setGeos(data.geos)
                //if(data.boosts) setCurBoosts(data.boosts)
                //if(data.paths) setPaths(data.paths)
            }
        }
            getStats()
    }, [userID, companyID, curPid, curGeo, cascadeType])


    const dailyData = () => {
        let values = []
            if(!dailyStats || dailyStats.length === 0) {
                return values;
            } else {
                values = dailyStats
            }
        if(values.length === 0) return []

        let rows = [];
        values.forEach(row => {
            //if(!(curPid === '' || curPid === '0') && curPid !== row.subpid) {}
            //else {
                rows.push({'id': row.hour, 'values': [
                    row.date,
                    '$' + row.revenue,
                    '$' + row.avg,
                    row.delta,
                    row.status
                ]});
            //}
        });
        return rows
    }

    const hourlyData = () => {
        let values = []
            if(!hourlyStats || hourlyStats.length === 0) {
                return values;
            } else {
                values = hourlyStats
            }
        if(values.length === 0) return []

        let rows = [];
        values.forEach(row => {
            //if(!(curPid === '' || curPid === '0') && curPid !== row.subpid) {}
            //else {
                rows.push({'id': row.hour, 'values': [
                    row.hour,
                    '$' + row.revenue,
                    '$' + row.avg,
                    row.delta,
                    row.status
                ]});
            //}
        });
        return rows
    }


    const subpidData = () => {
        let values = []
            if(!subpidStats || subpidStats.length === 0) {
                return values;
            } else {
                values = subpidStats
            }
        if(values.length === 0) return []

        let rows = [];
        values.forEach(row => {
            //if(!(curPid === '' || curPid === '0') && curPid !== row.subpid) {}
            //else {
                rows.push({'id': row.subpid, 'values': [
                    row.subpid,
                    row.leads_0_24,
                    row.leads_24_48,
                    row.avg_leads,
                    row.delta,
                    row.status
                ]});
            //}
        });
        return rows
    }


    const pathData = (type) => {
        let values = []
        if(type === 1) {
            if(!pathLeadStats || pathLeadStats.length === 0) {
                return values;
            } else {
                values = pathLeadStats
            }
        }
        else if(type === 2) {
            if(!pathRevStats || pathRevStats.length === 0) {
                return values;
            } else {
                values = pathRevStats
            }
        }
        else if(type === 3) {
            if(!pathSuccessStats || pathSuccessStats.length === 0) {
                return values;
            } else {
                values = pathSuccessStats
            }
        }
        if(values.length === 0) return []

        let rows = [];
        values.forEach(row => {
            //if(!(curPid === '' || curPid === '0') && curPid !== row.subpid) {}
            //else {
                rows.push({'id': row.pathid, 'values': [
                    row.path,
                    row.leads_0_24,
                    row.leads_24_48,
                    row.leads_48_72,
                    row.delta,
                    row.status
                ]});
            //}
        });
        return rows
    }

    const filterCascade = (e) => {
        let { value } = e.target;
        setHourlyStats([])
        setSubpidStats([])
        setPathLeadStats([])
        setPathRevStats([])
        setPathSuccessStats([])
        setCascadeType(value)
    }
    const filterPid = (e) => {
        let { value } = e.target;
        setHourlyStats([])
        setSubpidStats([])
        setPathLeadStats([])
        setPathRevStats([])
        setPathSuccessStats([])
        setCurPid(value)
    }
    const filterGeo = (e) => {
        let { value } = e.target;
        setHourlyStats([])
        setSubpidStats([])
        setPathLeadStats([])
        setPathRevStats([])
        setPathSuccessStats([])
        setCurGeo(value)
    }

    if(!tool) return <></>

    if(!pids) return <>No Data</>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
            <CascadeToolToggle title={tool.tool_name} description={tool.description} value={cascadeType} onChange={filterCascade} />
                <Form description={tool.description} noCard={true} >
                    <Row>
                        <Col md={6}>
                            <strong>Filters</strong>
                    {pids.length === 0 ? "" :
                    <Select
                        value={curPid}
                        label="SUBPID"
                        name="pid"
                        formValues={pids}
                        useDefault={false}
                        onChange={filterPid}
                        validate="string"
                        colSize="6"
                    />}
                    {geos.length === 0 ? "" :
                    <Select
                        value={curGeo}
                        label="GEOS"
                        name="geo"
                        formValues={geos}
                        useDefault={false}
                        onChange={filterGeo}
                        validate="string"
                        colSize="6"
                    />}
                    </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                        <CardHeader title="📈 Daily Revenue Volume (Last week)" description="Total Revenue per day over last 14 days" />
                        <DataTable hover={false} tableID="hour" fieldNames={dayFields} dataRows={dailyData()} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        <CardHeader title="📈 Hourly Revenue Volume (Last 24h - EST)" description="Total Revenue per hour over last 24-hours compared to the 7-day average for the same hour of the day" />
                        <DataTable hover={false} tableID="hour" fieldNames={hourFields} dataRows={hourlyData()} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        <CardHeader title="🚦 Path Performance (Leads)" description="Total Leads per path over the last 72 hours" />
                        <DataTable hover={false} tableID="hour" fieldNames={pathFields} dataRows={pathData(1)} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        <CardHeader title="🚦 Path Performance (Revenue)" description="Total Revenue per path over the last 72 hours" />
                        <DataTable hover={false} tableID="hour" fieldNames={pathFields} dataRows={pathData(2)} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        <CardHeader title="🚦 Path Performance (Success)" description="Success Rates per path over the last 72 hours" />
                        <DataTable hover={false} tableID="hour" fieldNames={pathFields} dataRows={pathData(3)} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        <CardHeader title="👥 Subpid Activity" description="Total Leads per subpid over last two days compared to 7-Day average" />
                        <DataTable hover={false} tableID="hour" fieldNames={subpidFields} dataRows={subpidData()} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        </Col>
                        {/*
                        <CardHeader title="Offer Success Rates" description="" />
                        <DataTable hover={false} tableID="success" fieldNames={successFields} dataRows={successData()} tableSettings={tableTypes.None} hideTotal={true} />
                        </Col>
                        <Col md={6}>
                            <CardHeader title="Desktop Flow Paths" description="Desktop Flows" />
                            { flows && flows.length > 0 ? 
                            <DataTable hover={false} tableID="flow" fieldNames={flowFields} dataRows={flowData(1)} tableSettings={tableTypes.None} hideTotal={true} />
                            : <Row><Col md={12} className='ml-4'>No Flow Paths available for this Cascade</Col></Row>
                            }
                            
                            <CardHeader title="Mobile Flow Paths" description="Mobile Flows" />
                            { flows && flows.length > 0 ? 
                            <DataTable hover={false} tableID="mflow" fieldNames={flowFields} dataRows={flowData(2)} tableSettings={tableTypes.None} hideTotal={true} />
                            : <Row><Col md={12} className='ml-4'>No Flow Paths available for this Cascade</Col></Row>
                            }
                        </Col>
                        */}
                    </Row>
                </Form>
                </Card>
                {/*
                <Form title="Path Boosting" description="Use the following tool to temporarily boost traffic for a Path. During their boost window they will receive 100% of the first cascade traffic (after AFF Coreg)." onSubmit={postBoost}>

                    <Row className='mt-4'>
                        <Col md={6}>
                        <strong>Schedule New Boost</strong><br/><br/>
                            {paths.length === 0 ? "" :
                            <Select
                                value={curPath}
                                label="PATH"
                                name="curPath"
                                formValues={paths}
                                useDefault={true}
                                onChange={setPath}
                                validate="number"
                                colSize="6"
                            />}
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={boostPid}>Subpid</FormLabel>
                                <Col md={6}>
                                <input id="boostPid" name="boostPid" type='text' value={boostPid} placeholder='Subpid' className="form-control" onChange={(e) => setBoostPid(e.target.value)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={boostHours}>Hours to Boost</FormLabel>
                                <Col md={6}>
                                <input id="boostHours" name="boostHours" type='number' value={boostHours} className="form-control" onChange={(e) => setBoostHours(e.target.value)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <Col md={9} className="text-center">
                                    <Card.Text>{formMessage}</Card.Text>
                                    <Button title="Boost!" className="info" />
                                </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                        <strong>Active Boosts</strong>
                        <DataTable hover={false} tableID="boosts" fieldNames={boostFields} dataRows={boostData()} tableSettings={tableTypes.None} hideTotal={true} />
                        
                        </Col>
                    </Row>
                </Form>
                */}
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(CascadeStatusDashboard), "Cascade Status"));